export class SearchEvent {

    public selectedItemId: string;
    public isSearchSuccess: boolean;
    public message: string;
    public selectedProperty: string;
    public selectedRow: any;
    public pageSize: number;
    public pageNumber: number;
    public createdRowIndex: number;

    constructor(public type: number) { }

}




// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/search/models/search-event.ts